module.exports = __webpack_public_path__ + "../static/media/banner.cecc0101.png";